import app from 'flarum/common/app';
app.initializers.add('fof-extension-releases-common', () => {
  //
});